import { useQuery } from "react-query";
import { useGlobalMessage } from "src/shared/context/globalMessage";
import { httpClient } from "src/shared/services/httpClient";

export default function useGetChamberInfoMessage(enabled: boolean | undefined) {
  const isError502Page = window.location.pathname === "/error502";
  const { chamberMessage } = useGlobalMessage();
  return useQuery({
    queryFn: () => httpClient.get("/public/getChamberInfoMessage"),
    queryKey: ["get-chamber-message", chamberMessage.date],
    retry: true,
    enabled: !!enabled && !isError502Page,
  });
}
